module.exports = __webpack_public_path__ + "f84f1afdbfb224793705fceea9726262.png";